import { render, staticRenderFns } from "./Carrera.vue?vue&type=template&id=7af7767d&"
import script from "./Carrera.vue?vue&type=script&lang=js&"
export * from "./Carrera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports